var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"propertyZone"}},[_c('div',{staticClass:"main"},[_vm._m(0),_c('section',[_c('advertise',{attrs:{"id":"ad"}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_bar"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"title"},[_vm._v("\n          社區代訂專區\n        ")]),_c('div',{staticClass:"tip"},[_vm._v("\n          給好夥伴專屬的好康資訊\n        ")])])])
}]

export { render, staticRenderFns }